export default __webpack_public_path__ + "static/media/Ally 9781408308158.f89fb555.jpg";